import {
  faCartShopping,
  faChartLine,
  faHome,
  faClapperboard,
  faFileLines,
  faHandshake,

} from '@fortawesome/free-solid-svg-icons';

import { environment } from 'src/environments/environment';

export interface ParamOptions {
  search?: string;
  view?: string;
  id?: number;
}

export interface NavigationOption {
  title: string;
  icon: any; // Typings say it should be IconDefinition, but TypeScript error says otherwise within the sidebar nav's HTML template.
  route: string | null;
  params?: ParamOptions | null;
  externalUrl?: string; // Added field for external URLs
  children?: NavigationOption[];
}

export const desktopMenuOptions: NavigationOption[] = [
  {
    title: 'Dashboard',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Country Rankings',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Leadership Barometer',
    icon: faChartLine,
    route: '/leadership-barometer/dashboard',
    params: null,
  },
  {
    title: 'Retailers',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Sustainability',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Technology',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Group Companies',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'People',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Briefings',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Data Packs',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Podcasts',
    icon: null,
    route: null,
    params: null,
  },
];


export const auxMenuOptions: NavigationOption[] = [
  {
    title: 'Settings',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Help Centre',
    icon: null,
    route: null,
    params: null,
  },
  {
    title: 'Log Out',
    icon: null,
    route: null,
    params: null,
  },
]